<template>
  <v-container class="filter-container">

    <v-card class="filter-card" >
      <v-container>
        <v-card class="switch-card mb-3 mt-3 pt-1 pb-1">
          <div class="filter-switch ml-2">
            <v-icon> mdi-view-grid </v-icon>
            <v-switch
              class="ml-5"
              v-model="displayMap"
              @change="toggleDisplay()"
              inset
            ></v-switch>
            <v-icon> mdi-map-marker </v-icon>
          </div>
        </v-card>
      </v-container>
      <v-container class="search-container">
        <v-text-field
          solo
          outlined
          v-model="filter.qword"
          placeholder="What are you looking for...?"
          prepend-inner-icon="mdi-magnify"
          width="100px"
          @input="applyFilters"
        ></v-text-field>
        <v-btn class="mt-2" @click="displayFilterPanel">Filters</v-btn>
      </v-container>
        <v-container class="filter-elements mt-3" v-if="displayFilter">
          <v-card>
            <v-card-text>
              Genre Selection
            </v-card-text>
            <v-autocomplete
              class="ml-4 mr-4"
              outlined
              deletable-chips
              multiple
              small-chips
              v-model="filter.genres"
              :items="listGenres"
              @change="applyFilters"
            ></v-autocomplete>
          </v-card>

          <v-card  >
            <v-card-text>
              Price Range
            </v-card-text>
            <v-range-slider
              class="ml-4 mr-4"
              range
              v-model="filter.priceRangeValue"
              :max="5"
              :tick-labels="ticksLabels"
              ticks="always"
              tick-size="4"
              @change="applyFilters"
            ></v-range-slider>
          </v-card>
        </v-container>
    </v-card>



  </v-container>

</template>

<script>

export default {
  name: "filter-component",

  props : ['listGenres','displayMap', 'toggleDisplay'],

  data: () => ({
    searchValue : "",
    ticksLabels : ['-','$','$$','$$$','$$$$','-'],
    displayFilter : false,
    filter: {
      qword: "",
      genres: "",
      limit : 20,
    priceRangeValue : [0, 5]

    },

  })
  ,

  methods : {
    displayFilterPanel() {
      this.displayFilter = !this.displayFilter
    },

    applyFilters() {
      this.filter.applied = true;
      this.filter.qword.trim() !== "";
      if (this.filter.genres !== ""){
        this.filter.genres = this.filter.genres.join(",")
      }
      this.$emit("apply-filters", this.filter);
      this.filter.genres = "";
    }
  }

}
</script>

<style scoped>
.search-container {
  display : grid;
  grid-template-columns: 10fr 1fr;
  grid-gap: 15px;
}

.filter-elements {
  display: grid;
  grid-template-columns: repeat(2, 50%);
  grid-gap: 5px;
}

.filter-container {
  width: 100%;
}
.filter-switch {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media screen and (max-width: 480px) {
  .filter-elements {
    grid-template-columns: 100%;
  }
}




</style>
